import { FilterdColumns } from '@oscar/table';
import { Button, Divider } from '@oscar/theme';
import { AREA, SECTION } from 'common/constants';
import React, { useEffect } from 'react';
import './style.scss';

const { OptionGroup } = FilterdColumns;

function FilterAreaSectionColumnTable(props: any) {
  const { setSelectedKeys, selectedKeys, confirm, visible } = props;

  useEffect(() => {
    if (!visible) {
      confirm();
    }
  }, [visible]);

  const handleClearFilter = () => {
    setSelectedKeys([]);
  };

  return (
    <div className="ant-table-column-filter-area-section">
      <div className="column-filter-flex">
        <OptionGroup
          noStyle
          title={<div className="each-column">Area</div>}
          selectedKeys={selectedKeys?.[0] || ''}
          setSelectedKeys={(selected: any) => {
            setSelectedKeys([selected, selectedKeys?.[1]]);
          }}
          data={Object.values(AREA).map(item => ({
            value: item.VALUE,
            label: item.TEXT,
          }))}
          groupClassName="checkbox-group-filter"
        />
        <Divider type="vertical" />
        <OptionGroup
          noStyle
          title={<div className="each-column">Section</div>}
          selectedKeys={selectedKeys?.[1] || ''}
          setSelectedKeys={(selected: any) => {
            setSelectedKeys([selectedKeys?.[0], selected]);
          }}
          data={Object.values(SECTION).map(item => ({
            value: item.VALUE,
            label: item.TEXT,
          }))}
          groupClassName="checkbox-group-filter"
        />
      </div>
      <Divider className="margin-divider" />
      <Button type="link" size="small" onClick={handleClearFilter}>
        Clear Filter
      </Button>
    </div>
  );
}

export default FilterAreaSectionColumnTable;
